import { useQuery } from '@tanstack/react-query';
import type { AcademySetupTaskId } from '@court-sync/shared';
import { academyService } from '../services/academy';
import { STALE_TIME } from '../queryClient';
import { unwrapApiData } from './unwrap';

export const setupChecklistQueryKey = (academyId: string) =>
  ['academies', academyId, 'setup-checklist'] as const;

const EMPTY_DONE: Record<AcademySetupTaskId, boolean> = {
  academy_profile: false,
  sports: false,
  courts: false,
  locations: false,
  coaches: false,
  age_groups: false,
  terms: false,
  lessons: false,
  programs: false,
  payments: false,
};

export function useAcademySetupProgress(academyId?: string | null) {
  return useQuery({
    queryKey: setupChecklistQueryKey(academyId ?? ''),
    queryFn: async () => {
      if (!academyId) {
        return { done: EMPTY_DONE, completedAt: null };
      }
      const response = await academyService.getSetupChecklistProgress(academyId);
      const data = unwrapApiData(response, 'Failed to load setup checklist progress');
      return {
        done: { ...EMPTY_DONE, ...data.done } as Record<AcademySetupTaskId, boolean>,
        completedAt: data.completedAt ?? null,
      };
    },
    enabled: Boolean(academyId),
    staleTime: STALE_TIME.SHORT,
    refetchOnMount: 'always',
  });
}
